import { StyleDeclarationValue, css } from 'aphrodite';
import moment from 'moment';
import * as React from 'react';
import { copyToClipboard } from '../../../models/UiUtils';
import { AdminPermission } from '../../../viewmodels/AdminViewModels';
import { IImportJob } from '../../../viewmodels/AppViewModels';
import { LoadingSpinner } from '../../../web/components/LoadingSpinner';
import { ClipboardIcon } from '../../../web/components/svgs/icons/ClipboardIcon';
import { brandPrimary, brandPrimaryHover } from '../../../web/styles/colors';
import { baseStyleSheet } from '../../../web/styles/styles';
import { ConditionalAccess } from '../ConditionalAccess';
import { styleSheet } from './styles';

interface IProps {
	className?: string;
	isReverting?: boolean;
	revertImport?(): void;
	onForceRevertImport?(): void;
	styles?: StyleDeclarationValue[];
	systemJob: IImportJob;
}

export const ImportJobUser: React.FC<IProps> = props => {
	const { className, styles, systemJob, revertImport, onForceRevertImport, isReverting } = props;
	const emailImportJob = systemJob?.jobType?.toLocaleLowerCase().startsWith('populatefrom') || undefined;
	const fileName = systemJob?.additionalFields?.importFileName;

	if (isReverting) {
		return (
			<div className={`${css(styleSheet.container, ...(styles || []))} import-job-user ${className || ''}`}>
				<LoadingSpinner type='small' />
			</div>
		);
	}

	const copyImportId = () => {
		copyToClipboard(systemJob.id);
	};

	return (
		<div className={`${css(styleSheet.container, ...(styles || []))} import-job-user ${className || ''}`}>
			<div className={css(styleSheet.jobType, baseStyleSheet.truncateText)}>
				{!!fileName && !emailImportJob ? fileName : 'Email Import Job'}
			</div>
			<div className={css(styleSheet.date)}>{moment(systemJob.dateCreatedUtc).format('MM-DD-YYYY - hh:mm:ss A')}</div>
			<div>{!emailImportJob && <span className={css(styleSheet.status)}>{systemJob.status}</span>}</div>
			<div className={css(styleSheet.revertContainer)}>
				<ConditionalAccess permission={AdminPermission.RevertImport}>
					{!onForceRevertImport && (
						<button className={css(baseStyleSheet.ctaButtonSmall)} onClick={revertImport}>
							Revert
						</button>
					)}
				</ConditionalAccess>
				<ConditionalAccess permission={AdminPermission.OnlyForDevelopers}>
					{!!onForceRevertImport && (
						<button className={css(baseStyleSheet.ctaButtonDestructiveSmall)} onClick={onForceRevertImport}>
							Force Revert
						</button>
					)}
				</ConditionalAccess>
				<span className={css(styleSheet.jobId)}>
					{systemJob.id}
					<ConditionalAccess permission={AdminPermission.OnlyForDevelopers} elseChildren={null}>
						<span className={css(styleSheet.copy)} onClick={copyImportId}>
							<ClipboardIcon fillColor={brandPrimaryHover} hoverColor={brandPrimary} />
						</span>
					</ConditionalAccess>
				</span>
			</div>
		</div>
	);
};
